import { DEFAULT_THEME, isThemeSupported, ThemeAlias } from '@neptune/shared/venus-domain';

import { DB_PERSISTED_THEME_CONFIG_KEY } from './theme-config-types';

export type ThemeStore = {
  getTheme(): ThemeAlias;
  setTheme(theme: ThemeAlias): void;
  isThemeConfigKeyValid(key: string): boolean;
};

export function createThemeStore(): ThemeStore {
  const themeStorageKey = 'neptune-theme';

  function getTheme(): ThemeAlias {
    const storedValue = localStorage.getItem(themeStorageKey) || DEFAULT_THEME;
    return isThemeSupported(storedValue) ? storedValue : DEFAULT_THEME;
  }

  function setTheme(theme: ThemeAlias): void {
    localStorage.setItem(themeStorageKey, theme);
  }

  function isThemeConfigKeyValid(key: string): boolean {
    return DB_PERSISTED_THEME_CONFIG_KEY === key;
  }

  return {
    getTheme,
    setTheme,
    isThemeConfigKeyValid,
  };
}

export const themeStore = createThemeStore();
